import React, { useState, useEffect, useContext } from 'react';

import { DcContext } from './context';
import Tip from './tip';

import FormState from '../formstate';

const Multiple = (props) => {

	// * state 
	const [selected, setSelected] = useState([]);
	const [checked, setChecked] = useState({});

	// * context 
	const appContext = useContext(DcContext);

	// * helpers 

	// takes an array of selected items and keeps state in sync
	const setSelectedAndChecked = (s) => {
		let c = {};
		s.forEach((sel) => {
			c[sel] = true;
		});
		setSelected(s); 
		setChecked(c);
	};

	const updateAppState = (sels) => {
		// set app state 
		const formState = appContext.getFormState();
		let values = selected;
		if (sels) {
			values = sels;
		}
		const updateType = props.updateType;
		const updateVal = props.updateVal;

		//console.log('setSelection', updateType, updateVal, values);
		formState.setSelection(updateType, updateVal, values);

		// track selected products 
		if (props.product) {
			if (sels && sels.length > 0) {
				formState.addProduct(props.product);
			} else {
				formState.removeProduct(props.product);
			}
		}	
		// set context
		appContext.setFormState(formState); 
	};

	const stateIncludesProduct = (prod) => {
		const formState = appContext.getFormState();
		return formState.includesProduct(prod);
	}	

	// * component mount/update
	useEffect(
		() => {
			//console.log('selected', props.selected);
			setSelectedAndChecked(props.selected);
		},
		[props.selected]
	); 

	// * events
	const onCheckChange = (event) => {
		//console.log(event.target, event.target.value, event.target.checked)
		let ckd = checked;
		//console.log('ckd', ckd);
		ckd[event.target.value] = event.target.checked;
		setChecked(ckd); 
		let sels = [];
		for (let prop in ckd) {
			if (ckd[prop]) {
				sels.push("" + prop);
			}
		}
		//console.log(ckd, sels);
		setSelected(sels); 
		updateAppState(sels);
	};

	const onClear = (event) => {
		event.preventDefault();
		const formState = appContext.getFormState();
		const updateType = props.updateType;
		const updateVal = props.updateVal;
		//formState.clearSelection(updateType, updateVal);
		// hack 
		formState.setSelection(updateType, updateVal, ['cleared']);
		// store product selections
		if (props.product) {
			formState.removeProduct(props.product);
		}
		// store it in context 
		appContext.setFormState(formState);
		//console.log('cleared?')
	};

	// * render 

	let checks = [];
	//console.log(props.options);
	props.options.forEach((opt, i) => {
		checks.push(
			<label key={i} className={checked[opt.value] ? "selected" : ""}>
				<input type="checkbox"
					onChange={onCheckChange}
					checked={checked[opt.value] == true}
					name={props.name}
					value={opt.value}
				/>{opt.label}
				<Tip tipText={opt.tip} num={i} />
			</label>
		);
	})

	let optClassNames = ["option-group"];
	optClassNames.push((selected.length > 0) ? "selected" : "unselected");
	if (!props.options || props.options.length == 0) {
		optClassNames.push("empty");
	}
	// hide product options if product not selected 
	if (props.productOpts && !stateIncludesProduct(props.productOpts)) {
		optClassNames.push("hidden");
	}

	const showClearLink = true; 
	const opened = !props.closed; 

	return (
		<div className={optClassNames.join(' ')}>
			<details className='option-details' open={opened}>
				<summary>
					<h3 className={props.headingType}>{props.heading}</h3>
				</summary>
				{checks}
				<a className={"clear-link " + (showClearLink ? "" : "display-none")} href='#' onClick={onClear}>clear</a>
			</details>
		</div>
	);

}

export default Multiple;
